const META_PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();

let initialized = false;
let lastPageView = null;

function canUseBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

// Only public, non-capability routes may load or call the pixel. The SDK also
// reads the browser URL itself, so a sanitized page_path alone is insufficient.
export function analyticsPath(path) {
  const pathname = String(path || '').split(/[?#]/)[0];
  return /^(?:\/|\/(?:blog(?:\/[a-z0-9-]+)?|privacy|terms|escrow|disputes|refund|about|contact))\/?$/i.test(pathname)
    ? pathname : null;
}

function safeBrowserLocation() {
  return canUseBrowser() && analyticsPath(window.location.pathname)
    && !window.location.search && !window.location.hash;
}

export function initMetaPixel() {
  if (!META_PIXEL_ID || !safeBrowserLocation()) return false;
  if (initialized) return true;

  if (!window.fbq) {
    const fbq = function fbqShim() {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
  window.fbq('init', META_PIXEL_ID);
  initialized = true;
  return true;
}

function track(eventName, params = {}) {
  if (!initMetaPixel()) return;
  window.fbq('track', eventName, params);
}

function trackCustom(eventName, params = {}) {
  if (!initMetaPixel()) return;
  window.fbq('trackCustom', eventName, params);
}

export function trackPageView(path) {
  const pagePath = analyticsPath(path || (canUseBrowser() ? window.location.pathname : ''));
  if (!pagePath || pagePath === lastPageView || !initMetaPixel()) return;
  lastPageView = pagePath;
  track('PageView', { page_path: pagePath });
}

export function trackSignUpClick(params = {}) {
  trackCustom('SignUpClick', params);
}

export function trackLead(params = {}) {
  track('Lead', params);
}

export function trackStartTransaction(params = {}) {
  trackCustom('StartTransaction', params);
}

export function trackCompleteRegistration(params = {}) {
  track('CompleteRegistration', params);
}

export function trackTransactionCreated(params = {}) {
  trackCustom('TransactionCreated', params);
}
